// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__7vkG8","btn-search":"SearchBar_btn-search__XPXd+","input":"SearchBar_input__V8-ey","dark":"SearchBar_dark__nZRj0"};